import {faIndustry} from '@fortawesome/free-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import React from 'react';
import {Image} from 'react-bootstrap';
import {withTranslation} from 'react-i18next';
import styled from 'styled-components';
import config from '../../../config/app';
import {dateFormatFR} from '../../../utils';
import defaultBrand from '../../../common/assets/img/store.png';
import DataTable from '../../../common/components/Datatable/Datatable';
import Screen from '../../../common/components/layout/Screen';
import Metadata from '../../../common/components/Metadata';
import {FILTER_EXPRESSION_OPERATOR, FILTER_OPERATOR} from '../../../common/constants';
import {GRAPHQL_QUERY_BRANDS} from '../../../common/queries/brand';
import AddBrand from './AddBrand';
import BrandRowAction from './BrandRowAction';

const Span = styled.span`
  font-family: 'Segoe UI Bold', sans-serif;
`;

const imgStyle = {
  maxHeight: 40,
  maxWidth: 80,
  height: 'auto',
  width: 'auto',
};

const displayImage = function(id, name, file, withDefault = true) {
  if (!file && !withDefault) {
    return null;
  }
  const fileUrl = file ? config.api_file_brand + id + '?token=' + file.token : defaultBrand;
  return <Image src={fileUrl} alt={name} style={imgStyle}/>;
};

const columns = t => [
  {
    Header: '#',
    accessor: 'id',
    sortable: true,
  },
  {
    Header: t('logo'),
    Cell: ({cell}) => displayImage(cell.value.id, cell.value.name, cell.value.file),
    accessor: row => row,
  },
  {
    Header: t('optionalLogo'),
    Cell: ({cell}) => displayImage(cell.value.id, cell.value.name, cell.value.extraFile, false),
    accessor: row => row,
  },
  {
    Header: t('name'),
    accessor: 'name',
    sortable: true,
  },
  {
    Header: t('creation'),
    Cell: ({cell}) => dateFormatFR({date: cell.value}),
    accessor: 'createdAt',
    sortable: true,
  },
  {
    Header: t('action'),
    Cell: ({cell}) => <BrandRowAction brand={cell.value}/>,
    accessor: row => row,
  },
];

const BrandView = ({t}) => {
  const [advancedFilters, setAdvancedFilters] = React.useState(null);
  const onSearch = search => setAdvancedFilters({
    operator: FILTER_EXPRESSION_OPERATOR.Or,
    filters: [{
      field: 'id',
      operator: FILTER_OPERATOR.Like,
      value: `%${search}%`,
    }, {
      field: 'name',
      operator: FILTER_OPERATOR.Like,
      value: `%${search}%`,
    }],
  });

  return (
    <Screen
      header={<Metadata meta={t('meta')} title={t('title')}/>}
      leftTitle={
        <>
          <FontAwesomeIcon icon={faIndustry} color={'rgb(201,0,95)'}/>
          <Span className="route-name">{t('brands')}</Span>
        </>
      }
      rightTitle={<AddBrand/>}>
      <DataTable
        query={GRAPHQL_QUERY_BRANDS}
        keyResult="brands"
        columns={columns(t)}
        onSearch={onSearch}
        advancedFilters={advancedFilters}
        defaultSort={{field: 'name'}}/>
    </Screen>
  );
};

BrandView.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('brand')(BrandView);
